import * as React from 'react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';

export class NoReferenceableOutputsMessage extends React.Component<any, any> {

    public render() {
        return <MessageBar messageBarType={ MessageBarType.error }>This journey does not have any global outputs configured nor does it have any controls configured that a) have outputs and b) do not reside in a looping control block. 
        This feature will not be available until either of these have been remedied.</MessageBar>
    }

}


// WEBPACK FOOTER //
// ./source/ts/components/common/no-referenceable-outputs-message.tsx